<template>
  <v-app-bar class="main-toolbar header-logged-out" dark app flat>
    <v-toolbar-title class="header-logged-out-logo">
      <v-img
        v-if="bucketUrl"
        height="60"
        contain
        width="350"
        position="left center"
        :src="`${bucketUrl}/brand/logo-white.svg`"
      />
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <div class="mr-5" v-if="type === 'teacher'">
      <v-btn
        icon
        large
        @click="redirectToHelpPage"
        class="header-help-icon pl-4"
      >
        <v-icon left>help</v-icon>
        Help
      </v-btn>
    </div>
    <div class="name ml-3 mr-2">
      <span class="ml-1" v-if="type === 'teacher'">
        Are you a student?
        <router-link class="nav-link" to="/student/login">
          Login here
        </router-link>
      </span>

      <span class="ml-1" v-else-if="type === 'student' && isSDECC !== true">
        Are you a teacher?
        <router-link class="nav-link" to="/teacher/login">
          Login here
        </router-link>
      </span>
      <span
        class="ml-1"
        v-else-if="$route.name == 'privacy' || $route.name == 'terms'"
      >
        <router-link class="nav-link" to="/">
          Home
        </router-link>
      </span>
    </div>
  </v-app-bar>
</template>
<script>
import Auth from '@/modules/auth/models/Auth'
import { mapMutations, mapState } from 'vuex'
import { TokenService } from '@/services/storage.service'
import Config from '@/modules/config/models/Config'

export default {
  name: 'HeaderLoggedOut',
  components: {},
  props: {
    type: {
      type: String
    },
    checkuser: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isSDECC: false
    }
  },
  computed: {
    ...mapState(['bucketUrl'])
  },
  methods: {
    ...mapMutations('snackbar', ['showSnackbar', 'showErrorSnackbar']),
    redirectToHelpPage() {
      this.$router.push('logged-out-support')
    }
  },
  async created() {
    let type = this.type === 'user' ? 'student' : this.type

    if (this.checkuser && type && TokenService.getToken(`jwt_${type}-exp`)) {
      try {
        await Auth.dispatch('me', `${type}s`)
        if (type === 'individual') {
          type = 'user'
        }

        if (Config.value('isSDECC') == 1) {
          this.isSDECC = true
          this.showSnackbar('Redirecting to user dashboard')
          this.$router.push('/user/dashboard/overview')
        } else {
          this.showSnackbar(`Redirecting to ${type} dashboard`)
          this.$router.push(`/${type}/dashboard/overview`)
        }
      } catch (error) {
        throw error
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.header-logged-out {
  .nav-link {
    color: #fdcc08;
    text-decoration: underline;
  }
}
</style>
